<script>
import FooterSection from '@components/navigation/footer/footer-section.vue'
import SubscribeForm from '@components/navigation/footer/subscribe-form.vue'

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    FooterSection,
    SubscribeForm
  },
  mixins: [
    Translatable
  ],
  data() {
    return {
      year: new Date().getFullYear(),
      subscription: false
    }
  },
  methods: {
    subscribe() {
      this.subscription = !this.subscription
    }
  },
}
</script>

<template>
  <footer class="justify-center footer">
    <div class="container footer-content">
      <FooterSection class="first-section">
        <router-link :to="{ name: 'passAndCard' }">{{ getTranslatedContent('FOOTER_pass_and_card') }}</router-link>
        <router-link to="/get-your-pass#using-coolpass">{{ getTranslatedContent('FOOTER_USING_COOLPASS') }}</router-link>
        <router-link to="/pass-and-card#how-you-save">{{ getTranslatedContent('FOOTER_how_you_save') }}</router-link>
        <router-link :to="{ name: 'getYourPass' }">{{ getTranslatedContent('FOOTER_get_your_pass') }}</router-link>
        <router-link to="/get-your-pass#sales-points">{{ getTranslatedContent('FOOTER_sales_points') }}</router-link>
        <router-link :to="{ name: 'reviews' }">{{ getTranslatedContent('FOOTER_reviews') }}</router-link>
      </FooterSection>
      <FooterSection>
        <router-link :to="{ name: 'attractions' }">{{ getTranslatedContent('ATTRACTIONS') }}</router-link>
        <router-link :to="{ name: 'attractions', query: { category: 'sightseeing' } }">{{ getTranslatedContent('FOOTER_sightseeing_tours') }}</router-link>
        <router-link :to="{ name: 'areas' }">{{ getTranslatedContent('FOOTER_areas') }}</router-link>
        <router-link :to="{ name: 'news', query: { type: 'notice' } }">{{ getTranslatedContent('FOOTER_closures') }}</router-link>
        <router-link :to="{ name: 'news', query: { type: 'whats-on' } }">{{ getTranslatedContent('FOOTER_whats_on') }}</router-link>
        <router-link :to="{ name: 'contactUs' }">{{ getTranslatedContent('FOOTER_contact_us') }}</router-link>
      </FooterSection>
      <FooterSection class="about-us">
        <router-link class="faq-btn" :to="{ name: 'faq' }">{{ getTranslatedContent('FOOTER_faq') }}</router-link>
        <router-link :to="{ name: 'aboutUs' }">{{ getTranslatedContent('FOOTER_about_us') }}</router-link>
        <router-link :to="{ name: 'termsAndConditions' }">{{ getTranslatedContent('FOOTER_terms_and_conditions') }}</router-link>
        <router-link :to="{ name: 'cancellationAndRefund' }">{{ getTranslatedContent('FOOTER_cancellation_and_refund') }}</router-link>
        <router-link :to="{ name: 'privacyPolicy' }">{{ getTranslatedContent('FOOTER_privacy_policy') }}</router-link>
        <!-- <router-link tag="li" :to="{ name: 'siteMap' }">{{ getTranslatedContent('FOOTER_sitemap') }}</router-link> -->
      </FooterSection>
      <div class="download-links">
        <p class="download">
          {{ getTranslatedContent('DOWNLOAD') }}
        </p>
        <p class="app-title">
          {{ getTranslatedContent('FOOTER_prague_coolpass_app') }}
        </p>
        <a href="https://apps.apple.com/us/app/prague-cool-pass/id1378275600" target="_blank">
          <div class="appstore"></div>
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.bookletia.coolpassprague" target="_blank">
          <div class="google-play"></div>
        </a>
      </div>
      <div class="news-and-updates">
        <div class="news-and-updates-title">
          {{ getTranslatedContent('NEWS_AND_UPDATES') }}
        </div>
        <div v-if="subscription" class="sub-container">
          <p class="news-and-updates-title">{{ getTranslatedContent('FOOTER_sub_text') }}</p>
        </div>
        <div v-else>
          <SubscribeForm @subscribe="subscribe"/>
        </div>
        <div class="footer-info-year">
          {{ getTranslatedContent('FOOTER_year_coolpass').replace( "$year", year) }}
        </div>
        <div class="footer-info">
          {{ getTranslatedContent('FOOTER_year_card').replace( "$year", year) }}
        </div>
        <p class="rights-reserved-block">
          {{ getTranslatedContent('ALL_RIGHTS_RESERVED_LABEL') }}
        </p>
      </div>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
@import '@design';

.footer {
  margin-top: 130px;
  width: 100%;
  height: 314px;
  background: $dark-blue;
}

.footer-content {
  display: flex;
  flex-direction: row;
  margin-top: 42px;

  a {
    text-decoration: none;
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600; // temp-text
    // font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    color: $white;
    margin-bottom: 10px;
    display: block;
  }
}

.first-section {
  margin-right: 27px;
}

.faq-btn {
  font-family: Open Sans Semibold, sans-serif !important; // temp-text
  font-weight: 600;
  line-height: 48px !important;
  font-size: 15px !important;
  height: 48px;
  background: $orange;
  border: 1px solid $orange;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 12px !important;
  width: auto;
}

.faq-btn:hover {
  background: $hover-orange;
  border: 1px solid $hover-orange;
}

.about-us {
  margin-left: 67px;
}

.download-links {
  margin-left: 44px ;
}

.app-title,
.download {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  // font-weight: 600; // temp-text
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;

  margin-bottom: 12px;
}

.download {
  text-transform: uppercase;
}

.download-link-mixin {
  height: 43.44px;
  cursor: pointer;
}

.appstore {
  @extend .download-link-mixin;
  background: url("../../../assets/images/appstore.png") center no-repeat;
  background-size: cover;
  margin-bottom: 10.67px;
  width: 157.13px;
}

.google-play {
  @extend .download-link-mixin;
  background: url("../../../assets/images/googleplay.png") center no-repeat;
  background-size: cover;
  height: 45.1px;
  width: 157.13px;
}

.news-and-updates {
  margin-left: 76px;
}

.news-and-updates-title {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  // font-weight: 600; // temp-text
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;

  margin-bottom: 17px;
}

.footer-info {
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold; // temp-text
  font-size: 23px;
  line-height: 30px;
  color: white;
}

.footer-info-year {
  @extend .footer-info;
  margin-top: 14px;
  margin-bottom: 5px;
}

.rights-reserved-block {
  width: 348px;
  height: 32px;
  margin-top: 51px;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  // font-weight: 600; // temp-text
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: $light-gray;
}

@media only screen and (min-width: $mobile-screen-width) and (max-width: $screen-width-xs) {
  .footer-content {
    flex-direction: column;
    margin-top: 30px;
  }

  .footer {
    height: auto;
    margin-top: 70px;
  }

  .news-and-updates {
    margin: 0;
  }

  .rights-reserved-block {
    font-size: 12px;
    line-height: 16px;
    width: 294px;
    text-align: left;
  }

  .first-section {
    margin-bottom: 32px;
  }

  .about-us {
    margin-top: 32px;
    margin-bottom: 32px;
  }

  .download-links {
    margin-left: 8px;
    margin-bottom: 32px;
  }

  .news-and-updates-title {
    margin-bottom: 13px;
  }

  .footer-info-year {
    margin-top: 22px;
    margin-bottom: 10px;
  }

  .rights-reserved-block {
    margin: 31px 8px 40px;
  }

  .footer-info-year,
  .footer-info {
    font-family: Marselis Pro, serif;
    font-style: normal;
    font-weight: bold; // temp-text
    // font-weight: normal;

    font-size: 19px;
    line-height: 25px;
    color: #FFFFFF;

    margin-left: 8px;
    margin-right: 8px;
  }

  .faq-btn {
    max-width: 157px;
  }
}
</style>
